import { useHistory, useParams } from 'react-router'
import { ListingDataProvider } from './context/listing-data'
import { ListingDashboardPageLayout } from './page-layout'
import { ListingDashboardModalsProvider } from './modals'

const ListingDashboardHome = () => {
  const { listingId } = useParams<{ listingId: string }>()
  const history = useHistory()

  return (
    <ListingDataProvider listingId={listingId}>
      <ListingDashboardModalsProvider history={history}>
        <ListingDashboardPageLayout />
      </ListingDashboardModalsProvider>
    </ListingDataProvider>
  )
}

export default ListingDashboardHome
